import React from 'react';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { PlanUpgradeFlow } from '../../../flows/planUpgrade';
import { ChangePassword } from '../../../flows/changePassword/ChangePassword';
import LiliNotification, { LiliNotificationType } from '../../../DesignSystem/LiliNotification/LiliNotification';
import { LiliToastDefaultConfig } from '../../../DesignSystem/LiliToast/LiliToast';
import { ChangeEmail } from '../../../flows/changeEmail/ChangeEmail';
import { ChangePhone } from '../../../flows/changePhone/ChangePhone';
import { ChangePersonalAddress } from '../../../flows/changeAddress/ChangePersonalAddress';

export enum AccountSettingsFlow {
  PLAN_UPGRADE,
  CHANGE_PASSWORD,
  NONE,
  CHANGE_EMAIL,
  CHANGE_PHONE,
  CHANGE_ADDRESS,
  CHANGE_BUSINESS_ADDRESS,
}

interface AccountSettingsFlowManagerProps {
  flowToShow: AccountSettingsFlow;
  onCloseFlow: (flow: AccountSettingsFlow) => void;
}

export const AccountSettingsFlowManager = ({ flowToShow, onCloseFlow }: AccountSettingsFlowManagerProps) => {
  const { t } = useTranslation();
  const flowToShowMap = {
    [AccountSettingsFlow.PLAN_UPGRADE]: (
      <PlanUpgradeFlow onCloseClick={() => onCloseFlow(flowToShow)} origin='Settings' />
    ),
    [AccountSettingsFlow.CHANGE_PASSWORD]: (
      <ChangePassword
        onClose={() => onCloseFlow(flowToShow)}
        onPasswordChanged={() => {
          onCloseFlow(flowToShow);
          toast(
            <LiliNotification
              type={LiliNotificationType.INFORMATIONAL}
              title={t('CHANGE_PASSWORD.SUCCESS.TITLE')}
              text={t('CHANGE_PASSWORD.SUCCESS.DESCRIPTION')}
              id='change-password-success-notification'
            />,
            {
              ...LiliToastDefaultConfig,
              position: toast.POSITION.BOTTOM_CENTER,
              closeOnClick: false,
              autoClose: false,
            },
          );
        }}
      />
    ),
    [AccountSettingsFlow.CHANGE_EMAIL]: <ChangeEmail onClose={() => onCloseFlow(flowToShow)} />,
    [AccountSettingsFlow.CHANGE_PHONE]: <ChangePhone onClose={() => onCloseFlow(flowToShow)} />,
    [AccountSettingsFlow.CHANGE_ADDRESS]: (
      <ChangePersonalAddress businessFlow={false} onClose={() => onCloseFlow(flowToShow)} />
    ),
    [AccountSettingsFlow.CHANGE_BUSINESS_ADDRESS]: (
      <ChangePersonalAddress onClose={() => onCloseFlow(flowToShow)} businessFlow />
    ),
    [AccountSettingsFlow.NONE]: <div />,
  };

  return <div>{flowToShowMap[flowToShow]}</div>;
};
